import { map, reduce, isEmpty, isNil } from 'lodash';

export const VIEW_SHORTLIST_PATH = 'VIEW_SHORTLIST_PATH';
export const VIEW_REHIRE_SHORTLIST_PATH = 'VIEW_REHIRE_SHORTLIST_PATH';
export const APPROVE_TIMESHEET_PATH = 'APPROVE_TIMESHEET_PATH';
export const CANCEL_POSITION_PATH = 'CANCEL_POSITION_PATH';
export const CREATE_JOB_PATH = 'CREATE_JOB_PATH';
export const CREATE_REHIRE_JOB_PATH = 'CREATE_REHIRE_JOB_PATH';
export const NEW_INVITATION_PATH = 'NEW_INVITATION_PATH';
export const LOGIN_PATH = 'LOGIN_PATH';
export const EXTEND_JOB_PATH = 'EXTEND_JOB_PATH';
export const TRANSFER_JOB_PATH = 'TRANSFER_JOB_PATH';
export const DASHBOARD_PATH = 'DASHBOARD_PATH';
export const JOBS_PATH = 'JOBS_PATH';
export const JOBS_TEMPLATES_PATH = 'JOBS_TEMPLATES_PATH';
export const JOB_DETAILS_PATH = 'JOB_DETAILS_PATH';
export const VIEW_PAST_TIMESHEETS_PATH = 'VIEW_PAST_TIMESHEETS_PATH';
export const WEPLOYEE_PROFILE_PATH = 'WEPLOYEE_PROFILE_PATH';
export const USERS_PATH = 'USERS_PATH';
export const TIMESHEETS_PATH = 'TIMESHEETS_PATH';
export const TIMESHEETS_NO_PARAMS_PATH = 'TIMESHEETS_NO_PARAMS_PATH';
export const UNAUTHORIZED_PATH = 'UNAUTHORIZED_PATH';
export const REPOST_JOB_PATH = 'REPOST_JOB_PATH';
export const REPOST_REHIRE_JOB_PATH = 'REPOST_REHIRE_JOB_PATH';
export const EDIT_BILLING_ACCOUNT_PATH = 'EDIT_BILLING_ACCOUNT_PATH';
export const SEARCH_PATH = 'SEARCH_PATH';
export const PROFILE_HIRE_PATH = 'PROFILE_HIRE_PATH';

export const SERVER_REDIRECT_PATHS = '/organisations/*';

const BASE_PATH = '/weployers';

const internalPaths = {
  [DASHBOARD_PATH]: `${BASE_PATH}/portals/dashboard`,
  [JOBS_PATH]: `${BASE_PATH}/portals/jobs`,
  [JOBS_TEMPLATES_PATH]: `${BASE_PATH}/portals/jobs/templates`,
  [JOB_DETAILS_PATH]: `${BASE_PATH}/portals/jobs/:jobId`,
  [USERS_PATH]: `${BASE_PATH}/portals/users`,
  [TIMESHEETS_NO_PARAMS_PATH]: `${BASE_PATH}/portals/timesheets/`,
  [TIMESHEETS_PATH]: `${BASE_PATH}/portals/timesheets/:timesheetId?`,
  [UNAUTHORIZED_PATH]: `${BASE_PATH}/portals/unauthorized`,
  [SEARCH_PATH]: `${BASE_PATH}/portals/search`,
};

const externalPaths = {
  [APPROVE_TIMESHEET_PATH]: '/timesheets/:timesheetId/approve_timesheets/new',
  [EDIT_BILLING_ACCOUNT_PATH]: '/billing_accounts/edit',
  [CANCEL_POSITION_PATH]: '/positions/:positionId/cancel_positions/new',
  [CREATE_JOB_PATH]: '/jobs/new',
  [CREATE_REHIRE_JOB_PATH]: '/rehire_jobs/new',
  [EXTEND_JOB_PATH]: '/jobs/:jobId/extension_requests/new',
  [NEW_INVITATION_PATH]: '/invitations/new',
  [LOGIN_PATH]: '/users/sign_in',
  [REPOST_JOB_PATH]: '/templates/jobs/new',
  [REPOST_REHIRE_JOB_PATH]: '/templates/rehire_jobs/new',
  [TRANSFER_JOB_PATH]: '/jobs/:jobId/transfers/new',
  [VIEW_SHORTLIST_PATH]: '/jobs/:jobId/shortlists/new',
  [VIEW_REHIRE_SHORTLIST_PATH]: '/jobs/:jobId/rehire_shortlists/new',
  [VIEW_PAST_TIMESHEETS_PATH]: '/positions/:positionId/timesheets',
  [WEPLOYEE_PROFILE_PATH]: '/profiles/:weployeeId',
  [PROFILE_HIRE_PATH]: '/profile_hire_jobs/new',
};

const processParams = (params) => {
  if (isEmpty(params)) { return ''; }

  return `?${map((params), (value, key) => `${key}=${value}`).join('&')}`;
};

const processPathParams = (path, pathParams) => (
  reduce((pathParams || {}), (acc, value, key) => acc.replace(`:${key}`, value), path)
);

export const getInternalPath = ({ pathName, params, pathParams }) => {
  const path = internalPaths[pathName];
  if (isNil(path)) { throw new Error(`Path ${pathName} could not be found`); }

  return `${processPathParams(path, pathParams)}${processParams(params)}`;
};

export const getExternalPath = ({ pathName, params, pathParams }) => {
  const path = externalPaths[pathName];
  if (isNil(path)) { throw new Error(`Path ${pathName} could not be found`); }

  return `${processPathParams(path, pathParams)}${processParams(params)}`;
};
